module.exports = __webpack_public_path__ + "static/img/seckill-bg.eed0b6d7.png";